import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(
    private router: Router,
  ) { }

  redirectTo(uri: string) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/' + uri]);
  }

  forceReloadSamePage() {
    this.redirectTo(this.router.url);
  }
}
